function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import 'vant/es/swipe/style';
import 'vant/es/swipe-item/style';

/**
 * 垂直轮播图组件
 * @component VerticalSwiper
 * @description 可复用的垂直方向自动轮播图UI组件
 */
export default {
  name: 'VerticalSwiper',
  props: {
    /**
     * 轮播图片数组
     * @type {Array<string>}
     */
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    autoplay: {
      type: Number,
      default: 3000
    },
    /**
     * 是否显示指示器
     * @type {boolean}
     */
    showIndicators: {
      type: Boolean,
      default: false
    },
    /**
     * 指示器颜色
     * @type {string}
     */
    indicatorColor: {
      type: String,
      default: '#1989fa'
    },
    /**
     * 是否开启循环播放
     * @type {boolean}
     */
    loop: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      currentIndex: 0,
      touchable: false,
      duration: 500
    };
  },
  computed: {
    /**
     * 显示的图片数组（循环模式下在末尾添加第一张）
     * @returns {Array<string>}
     */
    displayItems: function displayItems() {
      if (this.loop && this.items.length > 0) {
        return [].concat(_toConsumableArray(this.items), [this.items[0]]);
      }
      return this.items;
    }
  },
  methods: {
    /**
     * 轮播切换事件处理
     * @param {number} index - 当前索引
     */
    onChange: function onChange(index) {
      var _this = this;
      this.currentIndex = index;

      // 如果循环模式开启，且当前是最后一张（第一张的副本）
      if (this.loop && index === this.items.length) {
        // 使用 setTimeout 确保在动画完成后跳转，实现无缝循环
        // 这样第一张会从下方出现（因为最后一张向上滑动后，第一张的副本从下方进入，然后无缝跳转到真正的第一张）
        setTimeout(function () {
          _this.duration = 0;
          _this.$refs.swipeRef.swipeTo(0, false);
          setTimeout(function () {
            _this.duration = 500;
          }, 500);
        }, this.duration);
      }
    }
  }
};